<template>
  <div>
    <cant-transactions ref="CantTransactions" />
    <processed-docs ref="ProcessedDocs" />
    <pending-docs ref="PendingDocs" />
    <config-billing-date ref="ConfigBillingDate" />
    <config-max-amount-invoice ref="ConfigMaxAmountInvoice" />
    <config-trade-name ref="ConfigTradeName" />
    <config-contingency-auto ref="ConfigContingencyAuto" />
    <config-activar-dee ref="ConfigActivarDEE" />
    <config-activar-ticket ref="ConfigActivarTicket" />
    <config-address-optional ref="ConfigAddressOptional" />
    <config-email-optional ref="ConfigEmailOptional" />
    <modified-code-product ref="ModifiedCodeProduct" />
    <param-add-size-color ref="addTallaColorForm" />
  </div>
</template>

<script>


  export default {
    components: {
      ProcessedDocs: () => import('./components/ProcessedDocs'),
      PendingDocs: () => import('./components/PendingDocs'),
      ConfigBillingDate: () => import('./components/BillingDateConfigs'),
      ConfigMaxAmountInvoice: () => import('./components/MaxInvoiceAmount'),
      ConfigTradeName: () => import('./components/TradeNameConfigs'),
      ConfigContingencyAuto: () => import('./components/ContingencyAutoConfigs'),
      ConfigActivarDee: () => import('./components/ActivarDEEConfigs'),
      ConfigActivarTicket: () => import('./components/ActivarTicketConfigs'),
      ConfigAddressOptional: () => import('./components/AddressOptional'),
      ConfigEmailOptional: () => import('./components/EmailOptional'),
      CantTransactions: () => import('./components/CantTransactions'),
      ModifiedCodeProduct: () => import('./components/ModifiedCodeProduct'),
      ParamAddSizeColor: () => import('./components/ParamAddSizeColor'),
    },
  }
</script>
